mapboxgl.accessToken = process.env.MAPBOX_ACCESS_TOKEN;

const mapPadding = {
  left: 450,
  top: 100,
  bottom: 100,
  right: 100
};

const mapPosition = window.countryBBox
  ? {
      bounds: window.countryBBox
    }
  : // "NO DATA" earth globe view
    {
      center: [-78.262, 51.775],
      zoom: 1.4,
      projection: "globe"
    };

let map, marker;

function initializeMap() {
  if (map) {
    return;
  }

  map = new mapboxgl.Map({
    container: "map",
    projection: "mercator",
    style: process.env.MAPBOX_STYLE,
    interative: false,
    logoPosition: "top-right",
    ...mapPosition
  });

  map.setPadding(mapPadding);

  map.on("style.load", function() {
    // Hide country labels for "NO DATA" page
    if (!window.countryBBox) {
      map.setLayoutProperty("country-label", "visibility", "none");
    }
  });

  const control = new mapboxgl.NavigationControl();
  document.getElementById("map-controls").appendChild(control.onAdd(map));
}

export function zoomCountry() {
  cleanupMarker();
  if (map && window.countryBBox) {
    map.fitBounds(window.countryBBox);
  }
}

export function zoomCity() {
  cleanupMarker();
  if (map && window.cityCoords) {
    map.flyTo(
      { center: window.cityCoords, zoom: 12 },
      {
        padding: mapPadding
      }
    );
  }
}

export function zoomCompany(isAsn) {
  cleanupMarker();
  const coordsToZoom = isAsn ? window.asnCoords : window.companyCoords;

  if (map && coordsToZoom) {
    map.flyTo(
      { center: coordsToZoom, zoom: 16 },
      {
        padding: mapPadding
      }
    );

    marker = new mapboxgl.Marker().setLngLat(coordsToZoom).addTo(map);
  }
}

function cleanupMarker() {
  if (marker) {
    marker.remove();
    marker = null;
  }
}

const mapMedia = window.matchMedia(
  `(min-width: ${process.env.MAP_VISIBILITY_BP})`
);

if (mapMedia.matches) {
  initializeMap();
}

mapMedia.addEventListener("change", e => {
  if (e.matches) {
    initializeMap();
  }
});
